export function isAddress(address: string): boolean {
  return !!/^(0x)?[\dA-Fa-f]{40}$/.test(address)
}

export function formatAddress(address: string): string {
  if (!address) return ''
  if (!isAddress(address)) return address
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}